import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import GuideStrip from "./components/GuideStrip";
import LatestFeed from "./components/LatestFeed";
import PersonTimeline from "./components/PersonTimeline";
import CompilationIndex from "./components/CompilationIndex";
import YearTimeline from "./components/YearTimeline";
import DeepArchive from "./components/DeepArchive";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <GuideStrip />
        <LatestFeed />
        <PersonTimeline />
        <CompilationIndex />
        <YearTimeline />
        <DeepArchive />
      </main>
      <Footer />
    </div>
  );
}